import styled from 'styled-components';
import COLORS from '../../colors';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Grid } from '@mui/material';
import { StepIconProps } from '@mui/material/StepIcon';
import { Check } from '@mui/icons-material';
import StepConnector, {
  stepConnectorClasses
} from '@mui/material/StepConnector';
import { truncatePascalMonth } from '../../util';
import { MONTH_PASCAL } from '../../constants';

interface MonthProgressProps {
  steps: Array<string>;
  activeStep: number;
  onClick?: (step: string) => void;
}

const StyledStepLabel = styled(StepLabel)`
  .MuiStepLabel-label {
    color: ${COLORS.NEUTRAL_500};
    margin-top: 8px;
  }
  .MuiStepLabel-label.Mui-active {
    color: ${COLORS.WHITE};
  }
  .MuiStepLabel-label.Mui-completed {
    color: ${COLORS.CHECKED_SECONDARY};
  }
`;

const StyledConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 25
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 1,
    border: 0,
    backgroundColor: COLORS.NEUTRAL_700,
    margin: '0 8px'
  }
}));

const StyledStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: COLORS.NEUTRAL_800,
  zIndex: 1,
  color: COLORS.NEUTRAL_500,
  width: 20,
  height: 20,
  padding: '4px',
  fontSize: '12px',
  letterSpacing: '0.4px',
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: COLORS.BUTTON_PRIMARY_HOVER,
    cursor: 'pointer'
  },
  ...(ownerState.active && {
    backgroundColor: COLORS.PRIMARY_500,
    color: COLORS.WHITE,
    '&:hover': {
      backgroundColor: COLORS.BUTTON_SECONDARY_HOVER,
      cursor: 'pointer'
    }
  }),
  ...(ownerState.completed && {
    backgroundColor: COLORS.CHECKED,
    color: COLORS.CHECKED_FILLED,
    '&:hover': {
      backgroundColor: COLORS.BUTTON_SECONDARY_HOVER,
      cursor: 'pointer'
    }
  })
}));

const StyledStepIcon = (props: StepIconProps, icons: any) => {
  const { active, completed, className } = props;

  return (
    <StyledStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </StyledStepIconRoot>
  );
};

const MonthProgress = ({ steps, activeStep, onClick }: MonthProgressProps) => {
  const mapIcons = () => {
    let items = {};
    const length = steps.length;
    let count = 1;

    while (Object.keys(items).length < length) {
      if (activeStep > Object.keys(items).length) {
        items = {
          ...items,
          [count]: <Check />
        };
      } else {
        items = {
          ...items,
          [count]: <div>{count}</div>
        };
      }
      count++;
    }

    return items;
  };

  const handleClick = (label: string): void => {
    if (!onClick) {
      return;
    }

    onClick(label);
  };

  return (
    <Grid item xs={6} sx={{ marginBottom: '32px' }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<StyledConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StyledStepLabel
              onClick={() => handleClick(label)}
              StepIconComponent={(value) => StyledStepIcon(value, mapIcons())}
            >
              {truncatePascalMonth(label as MONTH_PASCAL)}
            </StyledStepLabel>
          </Step>
        ))}
      </Stepper>
    </Grid>
  );
};

export default MonthProgress;
